module.exports = __webpack_public_path__ + "stylesheets/landing-template_21f05f75ff1520c38fc96082892cca1e.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/landing-template.less
// module id = dy9G
// module chunks = 153